import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useParams } from "react-router-dom";
import Socialize from "../Pages/Socialize";
import CityFeeds from "../Pages/Socialize/CityFeeds";
import Updates from "../Pages/Socialize/Updates";
import CityLights from "../Pages/Socialize/CityLights";
import CityRocks from "../Pages/Socialize/CityRocks";
import { useSelector } from "react-redux";
import { getUser } from "../API/fetchExpressAPI";
import { Box, CircularProgress } from "@mui/material";
import Login from "../Pages/Socialize/Login";
import CityJunctions from "../Pages/Socialize/CityJunctions";
import TermsAndConditions from "../Pages/Socialize/TermsAndConditions";
import CoHelpers from "../Pages/Socialize/CoHelpers";
import Jobs_offered from "../Pages/Serve/Jobs_offered";
import ConnectWithUtilities from "../Pages/Socialize/ConnectWithUtilities";
import UtilitiesMain from "../Pages/Socialize/UtilitiesMain";
import StandardFit from "../Pages/Socialize/StandardFit";
import MunicipalCorporation from "../Pages/Socialize/MunicipalCorporation";
import GrievanceForm from "../Pages/Socialize/GrievanceForm";
import TradeLicense from "../Pages/Socialize/TradeLicense";
import Banners from "../Pages/Socialize/Banners";
import BannerMain from "../Pages/Socialize/BannerMain";
import BannersToday from "../Pages/Socialize/BannersToday";
import VendorLicense from "../Pages/Socialize/VendorLicense";
import Citizens from "../Pages/Socialize/Citizens";
import Sale from "../Pages/Socialize/Sale";
import Promotions from "../Pages/Socialize/Promotions";
import DailyDelivery from "../Pages/Socialize/DailyDelivery";
import CitizensMain from "../Pages/Socialize/CitizensMain";
import SocializeCommunity from "../Pages/Socialize/SocializeCommunity";
import TriggerElement from "../Pages/Socialize/TriggerElement";
import Booths from "../Pages/Socialize/Booths";
import SalesMount from "../Pages/Socialize/SalesMount";
import RoadRageBanners from "../Pages/Socialize/RoadRageBanners";
import BoothProducts from "../Pages/Socialize/BoothProducts";

function SocializeRoutes() {
  const token = useSelector((state) => state.auth.userAccessToken);
  const [checkUser, setCheckUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserType = async () => {
      if (token) {
        try {
          const response = await getUser(token);
          const user_type = response[0]?.user_type;
          setCheckUser(user_type || null);
        } catch (error) {
          console.error(error);
          setCheckUser(null); // fallback
        }
      }
      setLoading(false);
    };

    fetchUserType();
  }, [token]);

  const ProtectedRoute = ({ shopElement, memberElement }) => {
    if (loading) {
      return (
        <Box className="loading">
          <CircularProgress />
        </Box>
      );
    }

    if (checkUser === "shop") return shopElement;
    if (checkUser === "member") return memberElement;
    if (checkUser === "merchant") return shopElement;

    return <Navigate to="../login" />;
  };

  // Optional: Block all route rendering until user check is done
  // if (token && (loading || !checkUser)) {
  //   return (
  //     <Box className="loading">
  //       <CircularProgress />
  //     </Box>
  //   );
  // }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Socialize />} />
      <Route
        path="/city-feeds"
        element={
          <ProtectedRoute
            shopElement={<CityFeeds />}
            memberElement={<CityFeeds />}
          />
        }
      />
      <Route
        path="/updates"
        element={
          <ProtectedRoute
            shopElement={<Updates />}
            memberElement={<Updates />}
          />
        }
      />
      <Route
        path="/city-lights"
        element={
          <ProtectedRoute
            shopElement={<CityLights />}
            memberElement={<CityLights />}
          />
        }
      />
      <Route
        path="/city-rocks"
        element={
          <ProtectedRoute
            shopElement={<CityRocks />}
            memberElement={<CityRocks />}
          />
        }
      />
      <Route
        path="/city-junctions"
        element={
          <ProtectedRoute
            shopElement={<CityJunctions />}
            memberElement={<CityJunctions />}
          />
        }
      />
      <Route
        path="/city-junctions/terms-and-conditions"
        element={<TermsAndConditions />}
      />
      <Route path="/city-junctions/co-helpers" element={<ProtectedRoute
            shopElement={<CoHelpers />}
            memberElement={<CoHelpers />}
          />} />
      <Route
        path="/city-junctions/jobs-offered"
        element={
          <ProtectedRoute
            shopElement={<Jobs_offered />}
            memberElement={<Jobs_offered />}
          />
        }
      />
      <Route
        path="/city-junctions/utilities-main"
        element={
          <ProtectedRoute
            shopElement={<UtilitiesMain />}
            memberElement={<UtilitiesMain />}
          />
        }
      />
      <Route
        path="/city-junctions/connect-with-utilities"
        element={
          <ProtectedRoute
            shopElement={<ConnectWithUtilities />}
            memberElement={<ConnectWithUtilities />}
          />
        }
      />
      <Route
        path="/city-junctions/sales-mount"
        element={
          <ProtectedRoute
            shopElement={<SalesMount />}
            memberElement={<SalesMount />}
          />
        }
      />
      <Route
        path="/city-junctions/standard-fit"
        element={
          <ProtectedRoute
            shopElement={<StandardFit />}
            memberElement={<StandardFit />}
          />
        }
      />
      <Route
        path="/city-junctions/municipal-corporation"
        element={
          <ProtectedRoute
            shopElement={<MunicipalCorporation />}
            memberElement={<MunicipalCorporation />}
          />
        }
      />
      <Route
        path="/city-junctions/municipal-corporation/grievance-form"
        element={
          <ProtectedRoute
            shopElement={<GrievanceForm />}
            memberElement={<GrievanceForm />}
          />
        }
      />
      <Route
        path="/city-junctions/municipal-corporation/trade-license"
        element={
          <ProtectedRoute
            shopElement={<TradeLicense />}
            memberElement={<TradeLicense />}
          />
        }
      />
      <Route
        path="/city-junctions/municipal-corporation/vendor-license"
        element={
          <ProtectedRoute
            shopElement={<VendorLicense />}
            memberElement={<VendorLicense />}
          />
        }
      />
      <Route
        path="/banners"
        element={
          <ProtectedRoute
            shopElement={<BannerMain />}
            memberElement={<BannerMain />}
          />
        }
      />
      <Route
        path="/banners/city-hoardings"
        element={
          <ProtectedRoute
            shopElement={<Banners />}
            memberElement={<Banners />}
          />
        }
      />
      <Route
        path="/banners/banners-today"
        element={
          <ProtectedRoute
            shopElement={<BannersToday />}
            memberElement={<BannersToday />}
          />
        }
      />
      <Route
        path="/banners/road-rage-banners"
        element={
          <ProtectedRoute
            shopElement={<RoadRageBanners />}
            memberElement={<RoadRageBanners />}
          />
        }
      />
      <Route
        path="/citizens"
        element={
          <ProtectedRoute
            shopElement={<CitizensMain />}
            memberElement={<CitizensMain />}
          />
        }
      />
      <Route
        path="/citizens/socialize-community"
        element={
          <ProtectedRoute
            shopElement={<SocializeCommunity />}
            memberElement={<SocializeCommunity />}
          />
        }
      />
      <Route
        path="/citizens/trigger-element"
        element={
          <ProtectedRoute
            shopElement={<TriggerElement />}
            memberElement={<TriggerElement />}
          />
        }
      />

      <Route
        path="/citizens/shopping"
        element={
          <ProtectedRoute
            shopElement={<Citizens />}
            memberElement={<Citizens />}
          />
        }
      />
      <Route
        path="/citizens/sale"
        element={
          <ProtectedRoute
            shopElement={<Sale />}
            memberElement={<Sale />}
          />
        }
      />
      <Route
        path="/citizens/sale/daily-delivery"
        element={
          <ProtectedRoute
            shopElement={<DailyDelivery />}
            memberElement={<DailyDelivery />}
          />
        }
      />
      <Route
        path="/citizens/promotions"
        element={
          <ProtectedRoute
            shopElement={<Promotions />}
            memberElement={<Promotions />}
          />
        }
      />
      <Route
        path="/citizens/booths"
        element={
          <ProtectedRoute
            shopElement={<Booths />}
            memberElement={<Booths />}
          />
        }
      />
      <Route
        path="/citizens/booths/products"
        element={
          <ProtectedRoute
            shopElement={<BoothProducts />}
            memberElement={<BoothProducts />}
          />
        }
      />
    </Routes>
  );
}

export default SocializeRoutes;
